import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import GenericFormDrawer from '../../../components/GenericFormDrawer';
import { toUtcIso } from '../../../utils/Utils';
import { createMeeting } from '../config';

// PM Analitik Faz 2 (spec §9.3) — "Görüşme Hazırla": kişi önceden seçili 1:1 oluşturma (yalnız doğrudan astta; sunucu da
// "yalnız doğrudan yönetici" kuralını uygular). Oluşturma çekmecesi GenericFormDrawer (modal yok); uç mevcut 1:1 ucudur.
export default function PrepareMeetingDrawer({ row, onClose, onCreated }) {
  const { t } = useTranslation();
  const schema = useMemo(() => [
    {
      name: 'person', type: 'notice', grid: 12,
      content: row ? t('performance.workspace.team.meeting.person', { name: row.fullName }) : '',
    },
    { name: 'scheduledAt', label: t('performance.workspace.team.meeting.scheduledAt'), type: 'datetime', required: true, grid: 12 },
  ], [row, t]);

  return (
    <GenericFormDrawer
      open={!!row}
      onClose={onClose}
      title={t('performance.workspace.team.meeting.title')}
      schema={schema}
      submitLabel={t('performance.workspace.team.meeting.create')}
      onSave={async (values) => {
        if (!row) return false;
        const ok = await createMeeting(row.employeeId, toUtcIso(values.scheduledAt));
        if (ok) onCreated?.();
        return ok;
      }}
    />
  );
}
